<template>
  <l-columns>
    <a-loading :loading="casinoIntegrationOptionMeta.loading">
      <l-columns-column size="7">
        <l-rows>
          <o-form
            :inputs="inputs"
            :initial-values="casinoIntegrationOption"
            :title="$t('casinos.editCasinoIntegrationOption')"
            :subtitle="$t('common.dataType') +' : '+casinoIntegrationOption.dataType"
            :submit-text="$t('common.save')"
            @submit="editCasinoIntegrationOption"
          />
          <a-box>
            <o-form
              :title="$t('casinos.deleteCasinoIntegrationOption')"
              :subtitle="$t('casinos.deleteCasinoIntegrationOptionDescription')"
              submit-variant="danger"
              :submit-text="$t('common.delete')"
              @submit="deleteCasinoIntegrationOption"
            />
          </a-box>
        </l-rows>
      </l-columns-column>
    </a-loading>
  </l-columns>
</template>

<script>
  import { ABox, ALoading, LColumns, LColumnsColumn, LRows, OForm, } from 'codefabrik-gui-vue'
  import {
    useCasinoIntegrationOption, useDeleteCasinoIntegrationOption,
    useEditCasinoIntegrationOption
  } from '@/views/casinos/casinoHooks'

  export default {
    name: 'CasinoIntegrationOption',
    components: { LRows, LColumns, LColumnsColumn, OForm, ALoading, ABox },
    computed: {
      inputs () {
        return [
          {
            name: 'name',
            validators: 'required',
            properties: {
              label: this.$t('common.name')
            }
          },
          {
            name: 'description',
            properties: {
              label: this.$t('common.description')
            }
          }
        ]
      },
    },
    mixins: [
      useCasinoIntegrationOption(),
      useEditCasinoIntegrationOption(),
      useDeleteCasinoIntegrationOption(),
    ]
  }
</script>

<style scoped>

</style>
